import axios from "axios";
import { axiosRequest } from "../axios.config";

export const authApi = {
  register: async (params) => {
    const url = "Authentication/register";
    const response = await axiosRequest.post(url, params);
    return response;
  },
  checkEmail: async (params) => {
    const { email } = params;
    const url = `User/Check-Exist-Email?Email=${email}`;
    const response = await axiosRequest.get(url);
    return response;
  },
  codeValidator: async (params) => {
    const [email, working] = params.data;
    const url = "Authentication/Reset-Code-Number";
    const response = await axiosRequest.post(url, null, {
      params: { email, working },
    });
    return response;
  },
  forgotPassword: async (params) => {
    const [email] = params.data;
    const url = "Authentication/ForgetPassword";
    const response = await axiosRequest.post(url, null, {
      params: { email },
    });
    return response;
  },
  resetPassword: async (params) => {
    const [email, codeNumber, newPassword, comfirmPassword] = params.data;
    const url = "Authentication/ResetPassword";
    const response = await axiosRequest.post(url, {
      email,
      codeNumber,
      newPassword,
      comfirmPassword,
    });
    return response;
  },

  confirmValidator: async (params) => {
    const [email, codeNumber] = params.data;
    const url = "Authentication/Confirm";
    const response = await axiosRequest.post(url, null, {
      params: { email, codeNumber },
    });
    return response;
  },
  login: async (params) => {
    const url = "Authentication/login";
    const response = await axiosRequest.post(url, params);
    return response;
  },
  externalLogin: async (params) => {
    const [provider, token] = params;
    const url = "Authentication/ExternalLogin";
    const response = await axiosRequest.post(url, { provider, token });
    return response;
  },
  refreshToken: async (params) => {
    const url = "Token/refresh";
    const response = await axios.post(url, params, {
      baseURL: process.env.REACT_APP_API_BASE,
    });
    return response;
  },
};
